import React from "react";
import { Route } from "react-router";
import OrgForm from "./org/org-form";

export function getRouters(prefix: string) {
  return <Route path={`${prefix}/opm/org/new`} component={OrgForm} />;
}
